import { useQuery } from '@tanstack/react-query';
import { fetchAddOns } from '../services/smr-admin';
import type { AddOnListParams } from '../services/smr-admin';

export const addonKeys = {
    all:    ['smr', 'addons'] as const,
    list:   (params: AddOnListParams) => [...addonKeys.all, 'list', params] as const,
    detail: (id: string)              => [...addonKeys.all, 'detail', id]  as const,
};

export function useAddOnsQuery(params: AddOnListParams = {}) {
    return useQuery({
        queryKey: addonKeys.list(params),
        queryFn:  () => fetchAddOns(params),
    });
}
